"use client";

import ContactForm from "../components/ContactForm";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#fefaf7] flex flex-col justify-center">
      <ContactForm />
    </div>
  );
}
